/*
* @author 友人a丶
* @date 2022-07-11
* 全局接口
* */


const url = 'https://www.51beefind.com:8621';
const mapUrl = 'https://51beefind.com:10443';
export default {
    /*用户登录*/
    login: `https://www.beefindtech.com:8443/userservice/user/login`,
    /* 获取列表 */
    getDevList:`${url}/devrelevant/getbuildlist`,
    /* 获取标记列表 */
    getLabelList:`${url}/devicemanage/gettaglist`,
    /* 获取标签下的设备 */
    devtaglist:`${url}/devicemanage/devtaglist`,
    /* 获取项目详情 */
    getProjectInfo:`https://beefindtech.com:8443/mspringmvc/bllist`,
    /*MQTT服务器磁盘空间*/
    MQTTSERVERURL:'https://beefindtech.com:9632/status.php',
    /*地图服务器磁盘空间*/
    MAPSERVERURL:"https://www.beefindtech.com/subservice/disk_status.php",
    /*媒体服务器磁盘空间*/
    MEDIASERVERURL:"https://beefindtech.com:9632/mediasrv/status.php",
    /* 修改标签name */
    editTagName:`${url}/devicemanage/updatetag`,
    /* 新增标签 */
    insertTag:`${url}/devicemanage/intag`,
    /* 获取无归属设备列表 */
    getNoTagList:`${url}/devicemanage/notbinddev`,
    /*设备添加现有标签*/
    insertDevTage:`${url}/devicemanage/addtag`,
    /* 设备添加新标签 */
    insertDevNewTage:`${url}/devicemanage/addnewtag`,
    /* 更改设备标记 */
    changeTheDeviceTag:`${url}/devicemanage/savelabel`,
    /* 获取设备的标签 */
    getDevTagInfo:`${url}/devrelevant/getdevlabel`,
    /* 解绑设备的单个标签 */
    deviceDeletionTags:`${url}/devicemanage/dev-deltag`,
    // 获取屏幕的图片坐标
    getImageCoor:`${mapUrl}/-/api/http/getDeviceParam`,
    // 获取空满状态
    getEmptyFullStatus:`${mapUrl}/-/api/status/dev_info.ini`,
    // 更新车位框数组
    setParkCoor:`${mapUrl}/-/api/http/setSmallFrame`,
    // 获取车位识别结果
    getParkIdentify:`${mapUrl}/-/api/cap_result.#.json`,
    // 获取设备颜色
    getTheDeviceColor:`${mapUrl}/-/api/status/current_color.ini`,
    // 获取网关下的地锁
    getGatewayList:`${mapUrl}/-/api/lock_gate.conf`,
    // 获取网关下地锁的在线状态
    getGatewayonLineList:`${mapUrl}/-/api/slave_connect.map`,
    // 获取当前地锁
    getLocksInfo:'https://www.51beefind.com:9002/carposModuleList',
    // 获取当前掉线设备时间
    getMapDeviceError:"https://www.51beefind.com/getMapDeviceError",
    /* 查询全项目二维码 */
    queryCode:`${url}/devrelevant/devinfo`,
    // 获取设备视频日期列表
    getDevTimeList:`${mapUrl}/-/api/http/videodate`,
    // 获取设备视频日期下的时间列表
    getDevTimeVideo:`${mapUrl}/-/api/http/videolist`,
    // 获取设备图片日期列表
    getDevImageDateList:`${mapUrl}/-/api/http/picdate`,
    // 获取设备图片日期下的时间列表
    getDevTimeImage:`${mapUrl}/-/api/http/piclist`,
    // 获取GOS8设备最新版本
    getGos8Version:`${mapUrl}/1111/project/gos8/fh/patch_ver`,
    // 获取GOS8设备升级命令
    getGos8Upgrade:`${mapUrl}/1111/project/gos8/fh/patch.cmd`,
    // 获取AI盒子设备升级命令
    getAI8Upgrade:`${mapUrl}/1111/project/gos8/aibox/main.cmd`,
    // 获取GOS7设备最新版本
    getGos7Version:`${mapUrl}/1111/project/gos7/mtk/update/release.app_ver`,
    // 获取GOS7设备升级命令
    getGos7Upgrade:`${mapUrl}/1111/project/gos7/mtk/update/cmd.sh`,
    // 获取车位指示灯列表
    getCameraList:`https://www.51beefind.com/cameraList`,
    // 获取车位指示灯关联线
    getCameraLine:`https://www.beefindtech.com:8443/mapserve/parkRelevancyLine`,
    // 获取4G卡号列表
    getSimList:`https://www.51beefind.com/aibox/list`,
    //忽略列表
    ignoreType:"https://www.51beefind.com:8621/devrelevant/project/ignore"
}
